export const home = {
  heroTitle: '实物黄金',
  heroSubtitle: '现货预约',
  heroMainTitle: '每笔订单对应一笔现货黄金',
  heroTitleLine1: '实物黄金，透明可溯',
  heroTitleLine2: '安全放心，财富传承',
  heroSubTags: '实物黄金 · 透明可溯 · 安全放心',
  heroDesc: '以当日金价锁定价格，到期提取实物黄金',
  heroCta: '立即锁价',
  productLabel: '投资金条',
  productWeight: '50g',
  productBrand: 'Au9999',
  guaranteePhysicalGold: '实物保障',
  guaranteePhysicalGoldDesc: '100%实物黄金',
  guaranteeAuthority: '权威认证',
  guaranteeAuthorityDesc: '国检认证 | 品质保障',
  guaranteeTransparency: '安全透明',
  guaranteeTransparencyDesc: '信息公开 | 透明合规',
  physicalGuaranteeBadge: '实物保障',
  realGold: 'REAL GOLD',
  liveGoldPrice: '实时金价（Au9999）',
  liveUpdate: '实时更新',
  todayChange: '今日涨幅',
  moreMarket: '更多行情',
  marketRefTitle: '市场参考价',
  shGoldExchange: '上海黄金交易所 Au9999',
  shSilverExchange: '上海白银交易所 Ag9999',
  todayGoldRef: '今日金价参考',
  todaySilverRef: '今日银价参考',
  quickReserve: '快速预约',
  reserveOrders: '预约订单',
  performManage: '履约管理',
  performPay: '履约支付',
  quickReserveDesc: '即时锁定价格',
  reserveOrdersDesc: '随时查看进度',
  performManageDesc: '实物保障放心',
  performPayDesc: '安全便捷无忧',
  jinanPromise: '金安承诺',
  promiseValues: '专业 · 诚信 · 安全 · 透明',
  promiseSubtitle: '您的黄金资产，交给金安中国',
  marketRefAu: '市场参考价 Au9999',
  marketRefAg: '市场参考价 Ag9999',
  noticeTitle: '金安公告',
  serviceGuarantee: '预约服务 · 实物保障',
  guaranteeSecurity: '安全保障',
  guaranteeSecurityDesc: '银行级安全体系',
  guaranteeTransparent: '透明交易',
  guaranteeTransparentDesc: '实时行情公开透明',
  guaranteePhysical: '实物交割',
  guaranteePhysicalDesc: '到期可提取实物黄金',
  guaranteeService: '专业服务',
  guaranteeServiceDesc: '24小时客服在线',
  footerBrand: '金安中国',
  footerCopyright: '© 2026 金安中国. Physical Gold Custody & Security Guaranteed.',
  physicalGold: 'PHYSICAL GOLD',
  spotReserve: '现货预约',
  openPrice: '开仓价',
  currentPrice: '回购价',
  profitLoss: '盈亏',
  buyIn: '买入 IN',
  sellOut: '卖出 OUT',
  originalMargin: '原始保证金',
  currentMargin: '当前保证金',
  deferredFee: '延期费',
  riskLevel: '风险度',
  paidIn: '已补',
  paidOut: '已折',
  depositRecord: '订金记录',
  applyPerform: '申请履约',
  addDeposit: '补定金',
  withdrawDeposit: '拆定金',
  closePosition: '平仓',
  availableMargin: '可用定金',
  usedMargin: '已用定金',
  floatingProfit: '浮动盈亏',
  longWeight: '多',
  shortWeight: '空',
  netWeight: '净',
  noPosition: '暂无持仓',
  noCloseRecord: '暂无平仓记录',
  positionLoadFailed: '持仓数据加载失败',
  confirmDeposit: '确认补入',
  confirmWithdraw: '确认拆出',
  confirmClose: '确认平仓',
  cancelClose: '取消',
  closeWarning: '平仓后将立即结算盈亏，该持仓不可恢复。确认平仓前请仔细核对以上信息。',
  depositAmount: '补入金额',
  withdrawAmount: '拆出金额',
  currentDeposit: '当前保证金',
  availableDeposit: '可用定金',
  withdrawable: '可拆金额',
  keep10Percent: '需保留原始保证金的 10% 作为最低保证金',
  quickAmount1000: '¥1000',
  quickAmount3000: '¥3000',
  quickAmount5000: '¥5000',
  quickAmount10000: '¥10000',
  allAmount: '全部',
  maxAmount: '最大',
  errorInvalidAmount: '请输入有效的金额',
  errorInsufficientFunds: '可用定金不足',
  errorMaxWithdraw: '最多可拆 ¥{{amount}}（需保留10%原始保证金）',
  expectedProfit: '预计盈亏',
  openPriceLabel: '开仓价',
  closePriceLabel: '平仓价',
  holdTab: '持仓',
  closeTab: '平仓',
  selectAll: '全选',
};